<template>
  <dashboard-layout>
    <div class="container-fluid">
      <div class="col-md-6">
        <router-link to="/e-signature" class="icon text-gray-600">
          <i class="fas fa-arrow-left"></i> Back
        </router-link>
      </div>
      <br />
      <div class="card shadow light">
        <div class="card-body">
          <div v-if="!displayedContent">
            <h5><strong>Get Your Document Signed</strong></h5>
            <p>Send a Request to others for e-signing, approval, or other processing</p>
            <hr class="sidebar-divider">
            <form @submit.prevent="handleNext">
              <label for="notificationSubject" class="text-black" style="margin-bottom: 1px;" >Recipients<label class="text-danger">*</label></label>
              <p>
                Note: Requests are completed in Order
                </p>
              <!-- Recipients List -->
              <div v-for="(recipient, index) in recipients" :key="recipient.userId" class="recipient-row">
                <span class="recipient-number">{{ index + 1 }}</span>
                <i class="fas fa-signature"></i>
                <!-- Customized recipient dropdown -->
                <div class="recipient-dropdown">
                  <div class="recipient-info">
                    <div class="email-container">
                      <i class="far fa-envelope"></i>
                      <span class="recipient-email" :class="{ 'highlighted': isMyself(recipient.email) }">
                        {{ getRecipientEmail(recipient) }}
                      </span>
                      <span class="recipient-name" :class="{ 'highlighted': isMyself(recipient.email) }">
                        {{ getRecipientName(recipient) }}
                      </span>
                    </div>
                  </div>
                  <div class="dropdown-container" :class="{ 'recipient-selected': recipient.userId !== '' }">
                    <select
                      class="form-control"
                      v-model="recipient.userId"
                      @change="userSelectionChanged(index)"
                      :disabled="recipient.userId !== ''"
                      
                    >
                      <option value="" disabled>Select Recipient</option>
                      <option v-for="user in dropdownOptions" :key="user.UserId" :value="user.UserId">
                        {{ user.FirstName }} {{ user.LastName }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Remove recipient button -->
                <i v-if="recipient.userId !== ''" class="fas fa-times" @click="removeRecipient(index)"></i>
              </div>
              <hr class="sidebar-divider">
              <!-- Message input -->
              <div class="form-group col-md-9">
                <label for="requestName" class="text-black" style="margin-bottom: 1px;">Request Name</label>
                <input type="text" class="form-control" v-model="requestName" id="requestName" placeholder="Enter Request Name" required>
                <label for="requestType" class="text-black" style="margin-top: 10px;" >Request Type ( Note: Official Documents will be sent to Info-Sec for Auditing )<span class="text-danger" >*</span></label>
                <select class="form-control" v-model="requestType" id="requestType" required>
                  <option value="" disabled>Select Document type</option>
                  <option value="Official">Official</option>
                  <option value="Personal">Personal</option>
                </select>
                <label for="message" class="text-black" style="margin-top: 10px;">Message <span class="text-danger">*</span></label>
                <textarea class="form-control" id="message" v-model="message" rows="5" placeholder="Type your message here..." required></textarea>
              </div>
              <hr class="sidebar-divider">
              <!-- Files input -->
              <label for="notificationSubject" class="text-black" style="margin-bottom: 1px;">Files <span class="text-danger">*</span></label>
              <p>Type: Pdf only</p>
              <div class="selected-files">
                <div v-for="(file, index) in selectedFiles" :key="index" class="file-item">
                  {{ file.name }}
                  <span @click="removeSelectedFile(index)" class="remove-file">Remove</span>
                </div>
              </div>
              <div class="file-upload">
                <input type="file" @change="handleFileChange" ref="fileInput" multiple accept=".pdf" style="display: none" required />
                <div class="drag-drop-area" @dragover.prevent @drop="handleFileDrop">
                  <p>Drag & Drop files here or</p>
                  <button type="button" class="custombutton2" @click="openFileInput">Select Files</button>
                </div>
              </div>
              <!-- <div v-if="base64EncodedPDF">
              <p>Base64 Encoded PDF:</p>
              <textarea rows="10" :value="base64EncodedPDF" readonly></textarea>
            </div> -->
              <!-- Submit button -->
              <button type="submit" class="custombutton2 custombutton2-user custombutton2-block col-md-3">
                Next <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </form>
          </div>

          
          <div v-if="displayedContent" class="pdf-app-container">
    <!-- Pagination -->
    <pagination :totalPages="numPages" :currentPage="currentPage" @page-selected="handlePageSelected" />
    <hr class="sidebar-divider">

    <!-- Main content area -->
    <div class="pdf-content">
      <!-- Left side: Droppable zone for PDF -->
      <div></div>

      <!-- PDF canvas container -->
      <div class="pdf-container pdf-canvas-container" ref="pdfCanvasContainer" @dragover.prevent @drop.prevent="handleRecipientDrop">
        <canvas ref="pdfCanvas" style="border: 2px dashed #ccc;height: 900px;"></canvas>
      </div>

          <div class="recipient-list">
  <div class="recipient-header">
    <h5><strong>Recipients</strong></h5>
  </div>

  <!-- Instructions for Drag & Drop -->
  <p class="instruction-text">Drag & Drop recipients onto the document</p>

  <!-- Recipient Container -->
  <div class="recipient-container">
    <!-- Draggable Recipient Items -->
    <div
      v-for="(recipient, index) in filteredRecipients"
      :key="index"
      class="recipient-item"
      draggable="true"
      :style="{
        top: `${recipient.isDragging ? recipient.fixedTop : recipient.top}px`,
        left: `${recipient.isDragging ? recipient.fixedLeft : recipient.left}px`,
      }"
      @dragstart="handleDragStart($event, recipient, index)"
    >
      <i class="fas fa-signature"></i>
      {{ recipient.name }}
    </div>
  </div>

  <hr class="sidebar-divider">
  <p>Active Field</p>
  <div class="recipient-container2"></div>
  <button @click="undoLastDrag" class="undo-button">
      <i class="fas fa-undo"></i> Undo
    </button>
  <hr class="sidebar-divider">




  <div class="add-date-field-checkbox">
    <label>
      <input type="checkbox" v-model="addDateFields" :disabled="dateFields.length > 0"/>
      Add Date Fields (optional)
    </label>
  </div><br>

  <div v-if="addDateFields">
    <div class="date-field-header">
      <h5><strong>Date Fields</strong></h5>
    </div>
    <p class="instruction-text">Drag & Drop date fields onto the document</p>
    <div class="date-field-container">
      <div class="recipient-container-date">
    <div
      v-for="(recipientDate, index) in filteredRecipientsDate"
      :key="index"
      class="recipient-item-date"
      draggable="true"
      :style="{
        top: `${recipientDate.isDraggingforDate ? recipientDate.DatefixedTop : recipientDate.Datetop}px`,
        left: `${recipientDate.isDraggingforDate ? recipientDate.DatefixedLeft : recipientDate.Dateleft}px`,
      }"
      @dragstart="handleDragStartforDate($event, recipientDate, index)"
    >
      <i class="fas fa-calendar mr-2"></i>
       Date for {{ recipientDate.name }}
    </div>
  </div>

  <hr class="sidebar-divider">
  <p>Active Date Field</p>
  <div class="recipient-container-date"></div>

    </div>
    <button @click="undoLastDateFieldDrag" class="undo-button">
      <i class="fas fa-undo"></i> Undo
    </button>
  </div>
  <hr class="sidebar-divider">

  <button v-if="areFieldsDropped" @click="showCirculationModal = true" class="custombutton2 custombutton2-user custombutton2-block">
  Continue
</button>
  
</div>
</div>
</div>


        </div>
        </div>

        <div class="modal-overlay8" v-show="showCirculationModal">
  <Modal class="custom-modal8" v-show="showCirculationModal">
    <div class="modal-dialog8 circulation-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body row">
          <!-- Left Column: PDF Thumbnail -->
          <div class="col-md-6 left-column">
            <div class="pdf-thumbnail">
              <hr class="sidebar-divider">
              <label for="requestType" class="text-black"><strong>Document Type:</strong> {{ requestType }}</label>
              <canvas ref="pdfCanvas2" style="border: 10px #181616; height: 400px;"></canvas>
            </div>
          </div>

          <!-- Right Column: Request Details and Circular Flow -->
          <div class="col-md-6 right-column">

            <center><img src="../../components/img/esigncheck.svg" alt="Signature Image" class="signature-image2" /></center>
            <hr class="sidebar-divider">
            <!-- Request Details -->
            <div class="request-details">
            <div class="pdf-info">
              <label for="requestName" class="text-black">Request Name:</label>
              <p>{{ requestName }}</p>
            </div>
            <div class="pdf-info">
              <label for="message" class="text-black">Message:</label>
              <!-- Apply a class to limit height and add overflow for scroll -->
              <p class="scrollable-content">{{ message }}</p>
            </div>
          </div>


            <!-- Circular Flow -->
            <hr class="sidebar-divider">
            <p class="text-dark">Request Flow</p>
            <div class="circulation-flow">
              <!-- Sender -->
              <div class="circulation-step">
                <div class="circulation-icon sender-icon">
                  <i class="fas fa-user"></i>
                </div>
                <div class="circulation-label"><strong>Sender: </strong> {{ userFirstName }} {{ userLastName }}</div>
              </div>

              <!-- Recipients -->
                          <!-- Recipients -->
           
            <template v-for="(recipient, index) in filteredRecipients" :key="recipient.userId">
              <div class="circulation-arrow">
                <i class="fas fa-long-arrow-alt-down"></i>
              </div>
              <div class="circulation-step">
                <div class="circulation-icon recipient-icon">
                  <i class="fas fa-user"></i>
                </div>
                <div class="circulation-label">
                  <!-- Add a numbered label for each recipient -->
                  <strong>{{ index + 1 }}.</strong> {{ recipient.name }}
                </div>
              </div>
            </template>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="confirmSignatureRequest">
          Confirm
        </button>
          <button type="button" class="btn btn-dark" @click="showCirculationModal = false">
            Close
          </button>
        </div>
      </div>
    </div>
  </Modal>
</div>




  
  
    </div>
  </dashboard-layout>
</template>

  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import axios from 'axios';
  import * as pdfjsLib from 'pdfjs-dist/build/pdf';
  import Pagination from './Pagination.vue';

  let dataUri = null;
  // let scale = 0.8;




 
  
  export default {
    name: 'send-signature-request',
  
    components: {
      DashboardLayout,
      Pagination,

    },
  
    data() {
      return {

        currentPage: 1,
        addDateFields: false,
        pdfCanvas: null,
        numPages: 0,
        pdfDoc: null,
        requestName: '',
        message: '',
        originalPositions: [],
        signatureFields: [],
        dateFields: [],
        showCirculationModal: false,
        userFirstName: '',
        userLastName: '',
        senderUserId: '',
        requestType: '', 
        base64EncodedPDF: null,


        originalRecipients: [],
        users: [],
        selectedFiles: [],
        selectedFiles2: null,
        pdfCanvasContext: null,
        pdfUrl: '',
        displayUsers: [], 
        draggedRecipient: null,
        draggedDateRecipient: null,
        displayedContent: false,
        dropdownOptions: [],
        recipients: [
          {
            userId: '',
            email: '',
            order: 0,
            

          },
        ],
      };
    },

    computed: {

      areFieldsDropped() {
    const recipientIdsSignature = this.filteredRecipients.map(recipient => recipient.userId);
    const recipientIdsDate = this.filteredRecipientsDate.map(recipient => recipient.userId);

    const allRecipientsInSignatureFields = recipientIdsSignature.every(
      userId => this.signatureFields.some(recipient => recipient.recipient.userId === userId)
    );

    let allRecipientsInDateFields = true;

    if (this.addDateFields) {
      allRecipientsInDateFields = recipientIdsDate.every(
        userId => this.dateFields.some(recipient => recipient.recipient.userId === userId)
      );
    }

    return allRecipientsInSignatureFields && allRecipientsInDateFields;
  },


  filteredRecipients() {
    // Filter out recipients with empty userId or email
    const filtered = this.recipients.filter(recipient => recipient.userId && recipient.email);

    // Sort recipients based on the order property
    return filtered.sort((a, b) => a.order - b.order);
  },

    filteredRecipientsDate() {
      // Filter out recipients with empty userId or email and sort by top position
      const filtered = this.recipients.filter(recipient => recipient.userId && recipient.email);

      // Sort recipients based on the order property
      return filtered.sort((a, b) => a.order - b.order);
    },
  },



  
  mounted() {
  this.fetchUsers();
  this.userFirstName = sessionStorage.getItem('firstName');
  this.userLastName = sessionStorage.getItem('lastName');
  this.senderUserId = sessionStorage.getItem('userId');
  
},

  
    methods: {

      async confirmSignatureRequest() {
  // Perform necessary computations here

  console.log("Confirming Send request");

  // Create a FormData object
  const formData = new FormData();

  // Append fields to the FormData object
  formData.append('SenderUserID', this.senderUserId);
  formData.append('RequestName', this.requestName);
  formData.append('RequestType', this.requestType);
  formData.append('RequestDesc', this.message);
  formData.append('TotalRecipients', this.filteredRecipients.length);

  for (let i = 0; i < this.selectedFiles2.length; i++) {
    formData.append('PDFDoc', this.selectedFiles2[i]);
  }

  // Construct RecipientsData
  const recipientsData = this.constructRecipientsData();

  // Append RecipientsData as a JSON string
  formData.append('RecipientsData', JSON.stringify(recipientsData));
  

  try {
    const token = sessionStorage.getItem('token');

const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data',
    };
    const response = await axios.post('http://localhost:3033/api/app/signature-request', formData,{ headers: headers });

    // Handle response as needed
    console.log('Signature request saved:', response.data);

    // Close the modal or perform any other actions
    this.showCirculationModal = false;
  } catch (error) {
    // Handle errors
    console.error('Error saving signature request:', error);
  }
},

constructRecipientsData() {
  const recipientsData = [];

  this.filteredRecipients.forEach((recipient, index) => {
    const recipientData = {
      RecipientUserID: parseInt(recipient.userId, 10),
      RecipientEmail: recipient.email,
      OrderNumber: index + 1,
      SignatureField_X: `${this.signatureFields[index].x}`,
      SignatureField_Y: `${this.signatureFields[index].y}`,
      Signature_PageNumber: this.signatureFields[index].pageNumber,
      WithDateField: this.addDateFields,
      DateField_X: null,
      DateField_Y: null,
      Date_PageNumber: null,
    };

    // Add date field details if 'Add Date Fields' is checked
    if (this.addDateFields) {
      recipientData.DateField_X = `${this.dateFields[index].x}`;
      recipientData.DateField_Y = `${this.dateFields[index].y}`;
      recipientData.Date_PageNumber = this.dateFields[index].pageNumber;
    }

    recipientsData.push(recipientData);
  });

  return recipientsData;
},



    

      handleContinueButtonClick() {
    // Implement the logic to handle the continue button click
    console.log('Continue button clicked!');
  },

      isDragging(recipient) {
    return recipient === this.draggedRecipient && recipient.isDragging;
  },

  isDraggingforDate(recipient) {
    return recipient === this.draggedRecipient && recipient.isDraggingforDate;
  },


      initializeCanvas() {
      // Get the 2D context of the canvas
      this.pdfCanvasContext = this.$refs.pdfCanvas.getContext('2d');
    },

      handleDragOver(event) {
    event.preventDefault();
    console.log('Dragging over');
  },

  handleDragStart(event, recipient, index) {
  recipient.isDragging = true;
  console.log('Drag starting for signature:', recipient, index);
  event.dataTransfer.setData('text/plain', index);
  event.dataTransfer.setData('application/json', JSON.stringify(recipient));
  event.dataTransfer.setData('fieldType', 'signature'); // Add a type property
},

handleDragStartforDate(event, recipientDate, index) {
  recipientDate.isDraggingforDate = true;
  console.log('Drag starting for date:', recipientDate, index);
  event.dataTransfer.setData('text/plain', index);
  event.dataTransfer.setData('application/json', JSON.stringify(recipientDate));
  event.dataTransfer.setData('fieldType', 'date'); // Add a type property
},


undoLastDrag() {

  console.log('Undoing last drag for ', this.draggedRecipient);

  if (this.draggedRecipient) {
    // Find the index of the draggedRecipient in filteredRecipients
    const index = this.filteredRecipients.findIndex(recipient => recipient === this.draggedRecipient);
    console.log('FilteredRecipients are: ', this.filteredRecipients);
    console.log('Index found: ', index, 'For: ',this.draggedRecipient);

    if (index === -1) {
     

      console.log('Restored position:', this.filteredRecipients[index]);

      // Remove the recipient from the canvas
      this.removeRecipientFromCanvas(this.draggedRecipient);
    }

    // Clear the draggedRecipient after undo
    //this.draggedRecipient = null;

    // Log the updated state after the changes
    console.log('State after undo:', this.draggedRecipient);
  } else {
    console.warn('No recipient is currently being dragged. Nothing to undo.');
  }
},

undoLastDateFieldDrag() {

console.log('Undoing last date drag for ', this.draggedDateRecipient);

if (this.draggedDateRecipient) {
  // Find the index of the draggedRecipient in filteredRecipients
  const index = this.filteredRecipientsDate.findIndex(recipient => recipient === this.draggedDateRecipient);
  console.log('FilteredRecipients are: ', this.filteredRecipientsDate);
  console.log('Index found: ', index, 'For: ',this.draggedDateRecipient);

  if (index === -1) {
   

    console.log('Restored position:', this.filteredRecipientsDate[index]);

    // Remove the recipient from the canvas
    this.removeRecipientDateFromCanvas(this.draggedDateRecipient);
  }

  // Clear the draggedRecipient after undo
  //this.draggedRecipient = null;

  // Log the updated state after the changes
  console.log('State after undo:', this.draggedDateRecipient);
} else {
  console.warn('No recipient is currently being dragged. Nothing to undo.');
}
},


removeRecipientFromCanvas(recipient) {
  const signatureField = this.$refs.pdfCanvasContainer.querySelector(`#signatureField_${recipient.userId}`);
  if (!signatureField) {
    console.log(`Signature field not found for recipient with ID ${recipient.userId}.`);
    return;
  }

  console.log('Found signature field: ', signatureField);

  // Delay the removal by a short time
  setTimeout(() => {
    const parent = signatureField.parentNode;
      parent && parent.removeChild(signatureField);
      console.log(`Removed signature field for recipient with ID ${recipient.userId}`);

      // Remove the corresponding entry from the array
      this.signatureFields = this.signatureFields.filter(
      (field) => field.recipient.userId !== recipient.userId
    );

      this.redrawCanvas();
      this.redrawDateCanvas();
  }, 100); // Adjust the delay time as needed
},

removeRecipientDateFromCanvas(recipient) {
  const dateField = this.$refs.pdfCanvasContainer.querySelector(`#dateField_${recipient.userId}`);
  if (!dateField) {
    console.log(`Date field not found for recipient with ID ${recipient.userId}.`);
    return;
  }

  console.log('Found Datae field: ', dateField);

  // Delay the removal by a short time
  setTimeout(() => {
    const parent = dateField.parentNode;
      parent && parent.removeChild(dateField);
      console.log(`Removed signature field for recipient with ID ${recipient.userId}`);

      // Remove the corresponding entry from the array
      this.dateFields = this.dateFields.filter(
      (field) => field.recipient.userId !== recipient.userId
    );

      this.redrawCanvas();
      this.redrawDateCanvas();
  }, 100); // Adjust the delay time as needed
},

clearCanvas() {
  // Clear the entire canvas
  this.pdfCanvasContext.clearRect(0, 0, this.$refs.pdfCanvas.width, this.$refs.pdfCanvas.height);
},

redrawCanvas() {
  // Clear the canvas before redrawing

  const newuri = dataUri
  this.renderPdfOnCanvas(newuri);

  // Redraw all signature fields
  setTimeout(() => {
  this.signatureFields.forEach((field) => {
      // Use your existing drawRecipientOnCanvas function
      this.drawSignatureField2(field.recipient, field.x, field.y);
    });
  }, 1200);
},
redrawDateCanvas() {
  // Clear the canvas before redrawing


  // Redraw all signature fields
  setTimeout(() => {
  this.dateFields.forEach((field) => {
      // Use your existing drawRecipientOnCanvas function
      this.drawSignatureFieldForDate2(field.recipient, field.x, field.y);
    });
  }, 1200);
},



  removeSignatureField(id) {
    const signatureField = this.$refs.pdfContainer.querySelector(`#signatureField_${id}`);
    if (signatureField) {
      signatureField.remove();
    } else {
      console.error(`Signature field with ID signatureField_${id} not found.`);
    }
  },

  handleRecipientDrop(event) {
  event.preventDefault();
  const recipientIndex = event.dataTransfer.getData('text/plain');
  const recipient = JSON.parse(event.dataTransfer.getData('application/json'));
  const fieldType = event.dataTransfer.getData('fieldType'); // Get the field type

  const rect = this.$refs.pdfCanvas.getBoundingClientRect();
  const x = event.pageX - rect.left - window.scrollX;
  const y = event.pageY - rect.top - window.scrollY;

  if (fieldType === 'signature') {
    // Handle signature field drop
    recipient.fixedTop = 355;
    recipient.fixedLeft = 700;
    recipient.top = 50;
    recipient.left = 750;

    // Check if a signature field with the same ID already exists
    const existingSignatureField = this.$refs.pdfCanvas.querySelector(`#signatureField_${recipient.userId}`);
    
    if (!existingSignatureField) {
      const uniqueId = this.generateUniqueId();
      recipient.pageNumber = this.currentPage;

      this.recipients.splice(recipientIndex, 1, {
        ...recipient,
        id: uniqueId,
        top: y,
        left: x,
        isDragging: true,
        pageNumber: this.currentPage,
      });
      this.draggedRecipient = recipient;
      this.drawRecipientOnCanvas(recipient, x, y, this.currentPage);
    }
  } else if (fieldType === 'date') {
    
    recipient.DatefixedTop = 758;
    recipient.DatefixedLeft = 700;
    recipient.Datetop = 50;
    recipient.Dateleft = 750;

    const existingSignatureField = this.$refs.pdfCanvas.querySelector(`#dateField_${recipient.userId}`);

    if (!existingSignatureField) {
      const uniqueId = this.generateUniqueId();
      recipient.pageNumber = this.currentPage;

      this.recipients.splice(recipientIndex, 1, {
        ...recipient,
        id: uniqueId,
        Datetop: y,
        Dateleft: x,
        isDragging: true,
        pageNumber: this.currentPage,
      });
      this.draggedDateRecipient = recipient;
      this.drawRecipientOnCanvasForDate(recipient, x, y, this.currentPage);
    }
  }
},

handleRecipientDrop2(event) {
  event.preventDefault();
  const recipientIndex = event.dataTransfer.getData('text/plain');
  const recipient = JSON.parse(event.dataTransfer.getData('application/json'));

  const rect = this.$refs.pdfCanvas.getBoundingClientRect();
  const x = event.pageX - rect.left - window.scrollX;
  const y = event.pageY - rect.top - window.scrollY;

  recipient.fixedTop = 355;
  recipient.fixedLeft = 700;
  recipient.top = 50;
  recipient.left = 750;

  console.log('Drop coordinates:', x, y);

  // Check if a signature field with the same ID already exists
  const existingSignatureField = this.$refs.pdfCanvas.querySelector(`#signatureField_${recipient.userId}`);
  console.log('Exising Signature: ', existingSignatureField);
  console.log('Data for recipient: ', recipient);
  
  if (!existingSignatureField) {
    console.log('condition executed');
    const uniqueId = this.generateUniqueId();

    recipient.pageNumber = this.currentPage;

    
    this.recipients.splice(recipientIndex, 1, {
      ...recipient,
      id: uniqueId,
      top: y,
      left: x,
      isDragging: true,
      pageNumber: this.currentPage,
    });
    this.draggedRecipient = recipient;

    setTimeout(() => {
      console.log('Data after for recipient: ', recipient);
      }, 2000);

   

    

    this.drawRecipientOnCanvas(recipient, x, y, this.currentPage);
  }
},

generateUniqueId() {
  return '_' + Math.random().toString(36).substr(2, 9);
},



handleDragEnd(index) {
  // Update the original position when the drag ends
  this.recipients[index].isDragging = false;
},

drawRecipientOnCanvas1(recipient, x, y) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);

    const scale = this.getScale();

    console.log('Scale before calculation: ', scale);
    const canvasWidth = 500;  // Set your canvas width
    const canvasHeight = 600;  // Set your canvas height

    // Adjust x and y coordinates based on the scale and canvas dimensions
    const xOffset = 45;
    let scaledX = ((x / scale) * (canvasWidth / this.$refs.pdfCanvas.offsetWidth)) + xOffset;
    const yOffset = 85; // Adjust the value as needed
    let scaledY = ((y / scale) * (canvasHeight / this.$refs.pdfCanvas.offsetHeight)) + yOffset;

    console.log('Position after scale:', scaledX, scaledY);

    const signatureField = document.createElement('div');
    signatureField.id = `signatureField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 160, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 160, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText(recipient.name, scaledX + 30, scaledY + 28);

    this.signatureFields.push({
      recipient: {
        userId: recipient.userId,
        name: recipient.name,
      },
      x: scaledX,
      y: scaledY,
    });

    console.log('Signature field created:', signatureField);

    this.$refs.pdfContainer.appendChild(signatureField);

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('Stored Signature Field: ',recipient.signatureField)
  }
},

drawSignatureField(recipient, x, y, pageNumber, scale) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);

    console.log(`Scale for Droppage ${pageNumber}:`, scale);

    const yOffset = 20;
    const xOffset = 30;
    
    console.log('Logging calcuation for ScaleX:', x, '+', xOffset);
    console.log('Logging calcuation for ScaleY:', y, '+', yOffset);

    // Adjust x and y coordinates based on the scale and canvas dimensions
    
    let scaledX = x - xOffset;
     // Adjust the value as needed
    let scaledY = y - yOffset;

    console.log('Position after scale:', scaledX, scaledY);

    recipient.top = scaledX;
    recipient.left = scaledY;

    const signatureField = document.createElement('div');
    signatureField.id = `signatureField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 160, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 160, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText(recipient.name, scaledX + 30, scaledY + 28);

    this.signatureFields.push({
      recipient: {
        userId: recipient.userId,
        name: recipient.name,
      },
      x: scaledX,
      y: scaledY,
      type:'signature',
      pageNumber: pageNumber,
    });

    console.log('Signature field created:', signatureField);

    this.$refs.pdfCanvas.appendChild(signatureField);
    recipient.isDragging = false;

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('State of Recipient: ',recipient)
  }
},

drawSignatureFieldForDate(recipient, x, y, pageNumber, scale) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);

    console.log(`Scale for Droppage ${pageNumber}:`, scale);

    const yOffset = 20;
    const xOffset = 30;
    
    console.log('Logging calcuation for ScaleX:', x, '+', xOffset);
    console.log('Logging calcuation for ScaleY:', y, '+', yOffset);

    // Adjust x and y coordinates based on the scale and canvas dimensions
    
    let scaledX = x - xOffset;
     // Adjust the value as needed
    let scaledY = y - yOffset;

    console.log('Position after scale:', scaledX, scaledY);

    recipient.top = scaledX;
    recipient.left = scaledY;

    const signatureField = document.createElement('div');
    signatureField.id = `dateField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 200, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 200, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText('Date for '+recipient.name, scaledX + 30, scaledY + 28);

    this.dateFields.push({
      recipient: {
        userId: recipient.userId,
        name: recipient.name,
      },
      x: scaledX,
      y: scaledY,
      type:'date',
      pageNumber: pageNumber,
    });

    console.log('Date field created:', signatureField);

    this.$refs.pdfCanvas.appendChild(signatureField);
    recipient.isDragging = false;

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('State of Recipient: ',recipient)
  }
},

drawSignatureFieldForDate2(recipient, x, y) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);
    
    let scaledX = x;
    let scaledY = y;

    console.log('Position after scale:', scaledX, scaledY);

    recipient.top = scaledX;
    recipient.left = scaledY;

    const signatureField = document.createElement('div');
    signatureField.id = `dateField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 200, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 200, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText('Date for '+recipient.name, scaledX + 30, scaledY + 28);


    console.log('Date field created:', signatureField);

    this.$refs.pdfCanvas.appendChild(signatureField);
    recipient.isDragging = false;

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('State of Recipient: ',recipient)
  }
},

drawRecipientOnCanvas(recipient, x, y, pageNumber) {
    const scale = this.getScale();

    // Adjust x and y coordinates based on the scale
    const scaledX = x / scale;
    const scaledY = y / scale;

    recipient.pageNumber = pageNumber;

    this.drawSignatureField(recipient, scaledX, scaledY, pageNumber, scale);
  },

  drawRecipientOnCanvasForDate(recipient, x, y, pageNumber) {
    const scale = this.getScale();

    // Adjust x and y coordinates based on the scale
    const scaledX = x / scale;
    const scaledY = y / scale;

    recipient.pageNumber = pageNumber;

    this.drawSignatureFieldForDate(recipient, scaledX, scaledY, pageNumber, scale);
  },

  drawRecipientOnCanvas2(recipient, x, y, pageNumber) {
    const scale = this.getScale();

    // Adjust x and y coordinates based on the scale
    const scaledX = x / scale;
    const scaledY = y / scale;

    recipient.pageNumber = pageNumber;

    this.drawSignatureField2(recipient, scaledX, scaledY, pageNumber, scale);
  },

  drawSignatureField2(recipient, x, y) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);

    // Adjust x and y coordinates based on the scale and canvas dimensions
    
    let scaledX = x;
    let scaledY = y;

    console.log('Position after scale:', scaledX, scaledY);



    const signatureField = document.createElement('div');
    signatureField.id = `signatureField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 160, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 160, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText(recipient.name, scaledX + 30, scaledY + 28);



    console.log('Signature field created:', signatureField);

    this.$refs.pdfCanvas.appendChild(signatureField);
    recipient.isDragging = false;

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('State of Recipient: ',recipient)
  }
},


drawRecipientOnCanvas0(recipient, x, y) {
  if (this.pdfCanvasContext && this.$refs.pdfCanvas) {
    console.log('Drawing recipient:', recipient);
    console.log('Position:', x, y);

    const scale = this.getScale();

    console.log('Scale before calculation: ', scale);
   

    // Adjust x and y coordinates based on the scale and canvas dimensions
   
    let scaledX = x;
    let scaledY = y;

    console.log('Position after scale:', scaledX, scaledY);

    const signatureField = document.createElement('div');
    signatureField.id = `signatureField_${recipient.userId}`;
    signatureField.className = 'signature-field';

    this.pdfCanvasContext.fillStyle = '#ffffcc';
    this.pdfCanvasContext.fillRect(scaledX, scaledY, 160, 35);
    this.pdfCanvasContext.strokeStyle = '#ccc';
    this.pdfCanvasContext.strokeRect(scaledX, scaledY, 160, 35);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.font = '15px FontAwesome';
    this.pdfCanvasContext.fillText('\uf044', scaledX + 5, scaledY + 30);

    this.pdfCanvasContext.fillStyle = '#000';
    this.pdfCanvasContext.fillText(recipient.name, scaledX + 30, scaledY + 28);

    console.log('Signature field created:', signatureField);

    this.$refs.pdfCanvas.appendChild(signatureField);

    // Store the signature field element in the recipient object
    recipient.signatureField = signatureField;

    console.log('Stored Signature Field: ',recipient.signatureField)
  }
},




getScale() {
  if (!this.pdfCanvas) {
    console.error('Canvas element not found.');
    return 1; // Default scale if canvas not found
  }

  const viewportWidth = this.pdfCanvas.width;
  const pdfWidth = this.pdfCanvas.offsetWidth;
  const scale = pdfWidth / viewportWidth;

  console.log('Viewport Width:', viewportWidth);
  console.log('PDF Width:', pdfWidth);

  console.log(`Scale:`, scale);

  return scale;
},


  getSignatureFieldRef(index) {
      return `signatureField_${index}`;
},

 handleSignatureFieldDrop(updatedRecipients) {
      // Handle the updated recipient list after a signature field drop
      this.recipients = updatedRecipients;
},


 handleNext() {
  const pdfFile = this.selectedFiles[0];

  // Check if a file is selected
  if (pdfFile) {
    dataUri = URL.createObjectURL(pdfFile);

    // Set the data URI as the source for the iframe
    this.displayedContent = true;

    // Wait for the next tick to ensure the canvas is mounted
    this.$nextTick(() => {
      // Initialize the canvas before rendering the PDF
      this.initializeCanvas();

      // Render the PDF on the canvas
      this.renderPdfOnCanvas(dataUri);
      this.renderPdfOnCanvas2(dataUri);


       console.log('Main recipeint position: ', this.originalRecipientPositions);
       console.log('Original positions:', this.filteredRecipients);
    
    });
  }
},

// Update your renderPdfOnCanvas method
renderPdfOnCanvas(dataUri) {
  this.pdfCanvas = this.$refs.pdfCanvas;

  // Check if the canvas element is found
  if (!this.pdfCanvas) {
    console.error('Canvas element not found.');
    return;
  }

  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.269/pdf.worker.mjs';

  pdfjsLib.getDocument({
    url: dataUri,
  }).promise
    .then((pdfDoc) => {
      this.numPages = pdfDoc.numPages;
      const pageNumber = this.currentPage;

      return pdfDoc.getPage(pageNumber);
    })
    .then((page) => {
      const scale = 2.0; // Adjust the scale as needed
      const viewport = page.getViewport({ scale });

      // Check if the canvas dimensions can be set
      if (this.pdfCanvas) {
        // Set the canvas dimensions based on the PDF page dimensions
        this.pdfCanvas.width = viewport.width;
        this.pdfCanvas.height = viewport.height;

        // Render the PDF page on the canvas
        const renderContext = {
          canvasContext: this.pdfCanvas.getContext('2d'),
          viewport,
        };

        page.render(renderContext);
      } else {
        console.error('Canvas element not found.');
      }
    })
    .catch((error) => {
      console.error('Error rendering PDF on canvas:', error);
      this.$toast.open({
        message: 'Error rendering PDF on canvas.',
        type: 'error',
        duration: 3000,
      });
    });
},

renderPdfOnCanvas2(dataUri) {
  this.pdfCanvas2 = this.$refs.pdfCanvas2;

  // Check if the canvas element is found
  if (!this.pdfCanvas2) {
    console.error('Canvas element not found.');
    return;
  }

  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.269/pdf.worker.mjs';

  pdfjsLib.getDocument({
    url: dataUri,
  }).promise
    .then((pdfDoc) => {
      this.numPages = pdfDoc.numPages;
      const pageNumber = this.currentPage;

      return pdfDoc.getPage(pageNumber);
    })
    .then((page) => {
      const scale = 2.0; // Adjust the scale as needed
      const viewport = page.getViewport({ scale });

      // Check if the canvas dimensions can be set
      if (this.pdfCanvas2) {
        // Set the canvas dimensions based on the PDF page dimensions
        this.pdfCanvas2.width = viewport.width;
        this.pdfCanvas2.height = viewport.height;

        // Render the PDF page on the canvas
        const renderContext = {
          canvasContext: this.pdfCanvas2.getContext('2d'),
          viewport,
        };

        page.render(renderContext);
      } else {
        console.error('Canvas element not found.');
      }
    })
    .catch((error) => {
      console.error('Error rendering PDF on canvas:', error);
      this.$toast.open({
        message: 'Error rendering PDF on canvas.',
        type: 'error',
        duration: 3000,
      });
    });
},


handlePageSelected(page) {
      this.currentPage = page;
      this.renderPdfOnCanvas(dataUri);

      setTimeout(() => {
      this.signatureFields.forEach((field) => {
          // Use your existing drawRecipientOnCanvas function
          if(field.pageNumber === this.currentPage){
          this.drawSignatureField2(field.recipient, field.x, field.y);
          }
        });
        this.dateFields.forEach((field) => {
          // Use your existing drawRecipientOnCanvas function
          if(field.pageNumber === this.currentPage){
           
          this.drawSignatureFieldForDate2(field.recipient, field.x, field.y);
  
          }
        });
      }, 800);
    },


 
openFileInput() {
      this.$refs.fileInput.click();
},

handleFileChange(event) {
  const file = event.target.files[0];
  this.handleFiles([file]);
  this.selectedFiles2 = event.target.files;


},

 handleFileDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      this.handleFiles(files);
      this.selectedFiles2 = event.dataTransfer.files;

    },

    convertToBase64(file) {
  const reader = new FileReader();

  reader.onloadend = () => {
    const binary = atob(reader.result.split(',')[1]);
    let hex = '';

    for (let i = 0; i < binary.length; i++) {
      const byte = binary.charCodeAt(i).toString(16);
      hex += (byte.length === 1 ? '0' : '') + byte;
    }

    this.base64EncodedPDF = hex.toUpperCase();
  };

  reader.readAsDataURL(file);
},


 handleFiles(files) {
  for (let i = 0; i < files.length; i++) {
    const allowedExtensions = ['.pdf'];
    const fileExtension = files[i].name.substring(files[i].name.lastIndexOf('.')).toLowerCase();
    
    if (allowedExtensions.includes(fileExtension)) {
      this.selectedFiles.push(files[i]);
    } else {
      // Handle invalid file type
      console.warn('Invalid file type. Please upload only PDF documents.');
      this.$toast.open({
        message: 'Invalid file type. Please upload only PDF documents.',
        type: 'warning', 
        duration: 3000, 
      });
    }
  }
},

removeSelectedFile(index) {
    this.selectedFiles.splice(index, 1);
  },

isMyself(email) {
      // Check if the selected user's email matches the logged-in user's email
      return email === sessionStorage.getItem('email');
    },
    
getRecipientName(recipient) {
  // If the recipient is the logged-in user, display "Myself"
  // Otherwise, display the recipient's name if available, otherwise an empty string
  return this.isMyself(recipient.email) ? 'Myself' : (recipient.name || '');
},
    
getRecipientEmail(recipient) {
      // If the recipient is the logged-in user, display "Myself"
      return this.isMyself(recipient.email) ? 'Myself' : recipient.email;
},

getRecipientFirstName(recipient) {
    // If the recipient is the logged-in user, display "Myself"
    // Otherwise, display the recipient's First Name if available, otherwise an empty string
    return this.isMyself(recipient.email) ? 'Myself' : (recipient.FirstName || '');
  },

  getRecipientLastName(recipient) {
    // If the recipient is the logged-in user, display "Myself"
    // Otherwise, display the recipient's Last Name if available, otherwise an empty string
    return this.isMyself(recipient.email) ? 'Myself' : (recipient.LastName || '');
  },

  userSelectionChanged(index) {
  const selectedUser = this.users.find(user => user.UserId === this.recipients[index].userId);
  if (selectedUser) {
    // Update the recipient directly without using $set
    this.recipients[index] = {
      userId: selectedUser.UserId,
      email: selectedUser.Email,
      name: selectedUser.FirstName + ' ' + selectedUser.LastName,
      order: this.recipients.length, // Set the order property to the end of the array
    };

    // Add the selected user to a separate array for display
    this.displayUsers.push({
      UserId: selectedUser.UserId,
      FirstName: selectedUser.FirstName,
      LastName: selectedUser.LastName,
    });

    // Remove the selected user from the dropdown options
    const remainingOptions = this.dropdownOptions.filter(user => user.UserId !== selectedUser.UserId);
    this.dropdownOptions = [...remainingOptions];

    // Add an empty recipient for the next one
    this.recipients.push({ userId: '', email: '' });
  }
},



async fetchUsers() {
  try {
    const selectedUserIds = this.recipients.map(recipient => recipient.userId);
    const response = await axios.get(this.$config.GETUSERS_ENDPOINT);

    this.users = response.data.slice().filter(user => !selectedUserIds.includes(user.UserId));
    this.dropdownOptions = [...this.users]; // Initialize dropdownOptions
    this.displayUsers = [...this.users]; // Initialize displayUsers with the same values as users
  } catch (error) {
    console.error(error);
    this.$toast.open({
      message: error,
      type: 'error',
      duration: 3000,
    });
  }
},

removeRecipient(index) {
        this.recipients.splice(index, 1);
},
  
addRecipient() {
        this.recipients.push({ userId: '', email: '' });
},
  

    },
  };
  </script>
  
  <style scoped>

.scrollable-content {
  max-height: 150px; /* Set a maximum height as per your requirement */
  overflow-y: auto; /* Add vertical scrollbar if content exceeds the maximum height */
}


.signature-image2 {
    max-width: 50%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 0 0px rgba(0, 0, 0, 0.1);
  }

.custom-modal8 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80vw; /* Set a maximum width in relation to the viewport width */
  width: auto; /* Allow the modal to adjust its width based on content */
  z-index: 1001;
  transition: all 0.3s ease; 
}

.modal-overlay8 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  display: flex; /* Ensure children (columns) are displayed as flex items */
}

.left-column {
  width: 70%; /* Set the width for the left column */
}

.right-column {
  padding: 20px;
  background-color: #f8f9fa; /* Light gray background */
  border-radius: 10px;
}

.request-details {
  margin-bottom: 20px;
}



.circulation-dialog {
  width: 100%;
}

.pdf-info {
  margin-bottom: 10px;
}

.circulation-flow {
  background-color: #fff; /* White background for the circular flow */
  padding: 20px;
  border-radius: 10px;
}
.circulation-step {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.circulation-icon {
  font-size: 24px;
  margin-right: 10px;
}

.circulation-arrow {
  font-size: 20px;
  margin: 0 10px;
  color: #007bff; /* Blue color for arrows */
}

.sender-icon {
  color: #6F48FF;
}

.recipient-icon {
  color: #2ecc71;
}

.circulation-arrow {
  font-size: 20px;
  margin: 0 10px;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px;
  text-align: right;
}



.pdf-app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pdf-pagination {
  margin-top: 20px; /* Adjust as needed */
}

.pdf-content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.pdf-canvas-container {
 overflow-y: auto;
  margin: 0;
  padding: 0;
  border: 2px dashed #ccc;
  background-color: #ffff;
  width: 700px; /* Adjust as needed */
  height: 700px; /* Adjust as needed */
}

  .h11{
    font-size: 2px;
  }
  


iframe {
  background-color: #ccc;
  top: 0;
  left: 0;
}

canvas {
  background-color: #ccc;
  z-index: 1;
}

.signature-field {
  position: absolute;
  background-color: #ffffcc;
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
  height: 30px;
  width: 120px;
  font-size: 11px;
}
.recipient-item {
  position: absolute;
  background-color: #ffffcc;
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  margin-bottom: 5px;
  margin-left: 10px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100px;
  font-size: 9px;
}

.recipient-item-date {
  position: absolute;
  background-color: #ffffcc;
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  margin-bottom: 5px;
  margin-left: 10px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  height: 20px;
  width: 140px;
  font-size: 9px;
}

.recipient-item:hover {
  transform: scale(1.05);
}

.recipient-item-date:hover {
  transform: scale(1.05);
}

.recipient-list {
  margin-left: 20px;
}

.recipient-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.undo-button {
  margin-top: 20px;
  padding: 10px 15px;
  background-color: #a9991f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
  width: 70px;
  font-size: 10px;
}

.undo-button:hover {
  background-color: #2d8733;
}

.recipient-container {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  height: 50px;
  width: 150px;
}

.recipient-container-date {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  align-items: center;
  height: 50px;
  width: 180px;
}

.recipient-container2 {
  border: 1px solid #ddd;
  border-radius: 5px;
  height: 50px;
  width: 150px;
}


.recipient-item i {
  margin-right: 5px;
}



.file-upload {
  margin-top: 20px;
}

.drag-drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.selected-files {
  margin-top: 10px;
}

.file-item {
  margin-bottom: 5px;
}

.remove-file {
  color: #ff4646;
  cursor: pointer;
  margin-left: 5px;
}
  .recipient-selected .dropdown-container {
  display: none;
}

 .recipient-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.recipient-row span,
.recipient-row i {
  margin-right: 10px;
}

.recipient-dropdown {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 10px;
}

.recipient-info {
  padding: 8px;
  flex-grow: 1;
  height: 50px; /* Adjust the height as needed */
  display: flex;
  align-items: center;
}

.recipient-name {
  font-weight: bold;
  margin-right: 10px;
}

.recipient-email {
  /* Add highlighting styles here */
  padding: 5px;
  background-color: #cddfeb; /* Highlight color */
  color: #070707; /* Text color */
  border-radius: 3px; /* Rounded corners */
}
  .add-recipient-button {
    background-color: #6F48FF;
    color: #fff;
    padding: 10px;
    font-size: 14px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .add-recipient-button:hover {
    background-color: #8C6DFF;
  }

  
  .dropdown-container {
  position: relative;
}

.dropdown-container select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  background: transparent;
  padding: 8px 30px 8px 8px; /* Adjust the right padding as needed */
  width: 100%;
  cursor: pointer;
}

.dropdown-container i {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
}

.email-container {
  display: flex;
  align-items: center;
}

.email-container i {
  margin-right: 5px;
  color: #94999c; /* Adjust the color as needed */
  vertical-align: middle; /* Align the icon vertically with the text */
}

  </style>
  